export type {
  IMultiselectProps,
  IMultiselectOptions as ISelectOptions
} from './multiselect';

export { default } from './multiselect';
